import ogbonoImage from "../assets/17.jpeg";
import crayfishImage from "../assets/19.jpeg";
import sativaImage from "../assets/15.jpeg";
import instaMoiImage from "../assets/13.jpeg";
import yamFlourImage from "../assets/12.jpeg";
import locustBeansImage from "../assets/14.jpeg";
import yellowPapImage from "../assets/16.jpeg";
import milletPapImage from "../assets/18.jpeg";

export const formatPrice = (price) =>
  new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    maximumFractionDigits: 0,
  }).format(price);

export const productCatalog = [
  {
    slug: "ogbono",
    name: "Ogbono",
    title: "Ogbono (Sorted & Ground)",
    image: ogbonoImage,
    accent: "green",
    description:
      "Freshly sorted and finely ground ogbono for rich, smooth soups with consistent texture.",
    options: [
      { id: "ogbono-50g", label: "50g Ziploc Package", price: 800, description: "A compact resealable pack for small batches and quick weekday cooking." },
      { id: "ogbono-130g", label: "130g Plastic Package", price: 1500, description: "A sturdier family-size pack that keeps longer and stores neatly." },
    ],
  },
  {
    slug: "crayfish",
    name: "Crayfish",
    title: "Crayfish (Sorted & Ground)",
    image: crayfishImage,
    accent: "orange",
    description:
      "Clean, aromatic crayfish prepared for soups, stews, sauces, and everyday seasoning.",
    options: [
      { id: "crayfish-100g", label: "100g Ziploc Package", price: 1000, description: "Lightweight seasoning pack for home kitchens that want freshness without bulk." },
      { id: "crayfish-300g", label: "300g Jar Package", price: 2800, description: "Airtight jar packaging for households that use crayfish regularly." },
      { id: "crayfish-500g", label: "500g Ziploc Package", price: 4500, description: "A larger resealable bag for bigger families, events, or batch cooking." },
    ],
  },
  {
    slug: "yellow-pap",
    name: "Yellow Pap",
    title: "Spiced Yellow Pap",
    image: yellowPapImage,
    accent: "yellow",
    description: "Warm, spiced yellow pap prepared for easy breakfasts and nourishing light meals.",
    options: [
      { id: "yellow-pap-50g", label: "50g Ziploc Package", price: 800, description: "A small resealable portion for quick servings and easy storage." },
      { id: "yellow-pap-130g", label: "130g Ziploc Package", price: 1500, description: "A more generous pack for repeat breakfasts and family portions." },
    ],
  },
  {
    slug: "millet-pap",
    name: "Millet Pap",
    title: "Spiced Millet Pap",
    image: milletPapImage,
    accent: "lime",
    description: "Smooth millet pap with balanced spice, ideal for wholesome breakfasts and soft meals.",
    options: [
      { id: "millet-pap-50g", label: "50g Ziploc Package", price: 800, description: "A smaller pack that stays fresh and suits lighter usage." },
      { id: "millet-pap-130g", label: "130g Ziploc Package", price: 1500, description: "A larger pack for steady household use and convenient meal prep." },
    ],
  },
  {
    slug: "insta-moi",
    name: "Insta Moi",
    title: "Insta Moi (Powdered Beans)",
    image: instaMoiImage,
    accent: "amber",
    description: "Ready-to-mix bean flour for fast moi-moi preparation without losing homemade flavor.",
    options: [
      { id: "insta-moi-1kg", label: "1kg Ziploc Package", price: 2500, description: "Convenient family-size bag for regular homemade moi-moi." },
      { id: "insta-moi-5kg", label: "5kg Ziploc Package", price: 10500, description: "Bulk pack suited to larger households, events, and food businesses." },
    ],
  },
  {
    slug: "yam-flour",
    name: "Yam Flour",
    title: "Real Yam Flour",
    image: yamFlourImage,
    accent: "stone",
    description: "Smooth yam flour for dependable amala texture and a clean, satisfying finish.",
    options: [
      { id: "yam-flour-1kg", label: "1kg Ziploc Package", price: 2500, description: "A resealable household pack that balances freshness and convenience." },
      { id: "yam-flour-5kg", label: "5kg Ziploc Package", price: 10500, description: "Bulk packaging for frequent cooking or larger family consumption." },
    ],
  },
  {
    slug: "sativa-poundo",
    name: "Sativa Poundo",
    title: "Sativa Poundo (Ziploc Packaged)",
    image: sativaImage,
    accent: "gold",
    description: "Fine poundo flour with a smooth finish for soft swallow and dependable consistency.",
    options: [
      { id: "sativa-poundo-1kg", label: "1kg Ziploc Package", price: 2500, description: "A standard home-use size that stays fresh between servings." },
      { id: "sativa-poundo-5kg", label: "5kg Ziploc Package", price: 10500, description: "A larger supply for bigger families, events, and repeat cooking." },
    ],
  },
  {
    slug: "locust-beans",
    name: "Locust Beans",
    title: "Locust Beans (Ziploc Packaged)",
    image: locustBeansImage,
    accent: "emerald",
    description: "Clean, dried iru prepared to bring deep umami flavor into traditional soups and stews.",
    options: [
      { id: "locust-beans-1kg", label: "1kg Ziploc Package", price: 2500, description: "A practical home-use size for steady, everyday cooking." },
      { id: "locust-beans-5kg", label: "5kg Ziploc Package", price: 10500, description: "Bulk storage option for high-usage homes and vendors." },
    ],
  },
];

export const productMap = Object.fromEntries(productCatalog.map((product) => [product.slug, product]));
export const getProductBySlug = (slug) => productMap[slug];
export const getCartCountFromItems = (items) => items.reduce((count, item) => count + item.quantity, 0);
